import {
  GET_SERVICE,
  GET_SERVICE_SUCCESS,
  GET_SERVICE_FAIL,

  FLAG_SERVICE,
  FLAG_SERVICE_SUCCESS,
  FLAG_SERVICE_FAIL
} from '../constants/serviceManager';
import client from '../../client';

export const getServices = () => dispatch => {
  dispatch({
    type: GET_SERVICE
  });
  client
    .get('serviceManager')
    .then(({data}) => {
      dispatch({
        type: GET_SERVICE_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_SERVICE_FAIL,
        error
      })
    })
}

export const restartService = (pid) => dispatch => {
  dispatch({
    type: FLAG_SERVICE
  });
  client
    .post('serviceManager', { pid })
    .then(({data}) => {
      console.log(data);
      dispatch({
        type: FLAG_SERVICE_SUCCESS,
        data: data
      })
    })
    .catch(error => {
      dispatch({
        type: FLAG_SERVICE_FAIL,
        error
      })
    })

}



// WEBPACK FOOTER //
// ./src/redux/actions/serviceManager.js